// src/components/EmptyState.jsx
import styles from './EmptyState.module.css';

export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconBadge}>
        {Icon && <Icon size={32} aria-hidden="true" />}
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      {action && action}
    </div>
  );
}
